<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'
import LoadingSpinner from '@/components/common/LoadingSpinner/LoadingSpinner.vue'
import { verifyMolliePaymentFn } from '@/services/api/restApiCalls'
import { useRestoGLobalStore } from '@/stores/restoGlobalStore'
import { useCartGLobalStore } from '@/stores/cartGlobalStore'

const route = useRoute()
const router = useRouter()
const restoStore = useRestoGLobalStore()
const cartStore = useCartGLobalStore()

const isVerifying = ref(true)
const orderId = ref(null)
const orderStatus = ref(null)
const pollCount = ref(0)
let pollTimer = null

const verifyPayment = async () => {
  if (!orderId.value) {
    orderStatus.value = 'FAILURE'
    isVerifying.value = false
    return
  }

  try {
    const response = await verifyMolliePaymentFn(restoStore?.RESTO_ID, orderId.value)
    orderStatus.value = response?.order_status

    if (orderStatus.value === 'REQUIRES_ACTION' && pollCount.value < 5) {
      pollCount.value += 1
      pollTimer = setTimeout(verifyPayment, 2000)
      return
    }

    if (orderStatus.value === 'AUTHORIZED' || orderStatus.value === 'SUCCESS') {
      cartStore.CART_DATA = ''
      router.replace({
        name: 'order_status',
        params: { order_id: `${orderId.value}` }
      })
      return
    }

    isVerifying.value = false
  } catch (err) {
    orderStatus.value = 'FAILURE'
    isVerifying.value = false
  }
}

onMounted(() => {
  orderId.value =
    route.query.order_id ||
    sessionStorage.getItem('mollie_order_id') ||
    null
  verifyPayment()
})

onBeforeUnmount(() => {
  if (pollTimer) clearTimeout(pollTimer)
})
</script>

<template>
  <AppLayout>
    <div class="container mx-auto md:pt-12 pt-8 pb-5">
      <div class="max-w-lg mx-auto bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-sm p-6 text-center">
        <div v-if="isVerifying" class="space-y-4">
          <LoadingSpinner :isLoading="true" />
          <p class="text-gray-700 dark:text-gray-200">Verifying your payment...</p>
        </div>

        <div v-else-if="orderStatus === 'FAILURE' || orderStatus === 'CANCELLED'" class="space-y-4">
          <h1 class="text-xl font-semibold text-red-600 dark:text-red-400">Payment Failed</h1>
          <p class="text-gray-600 dark:text-gray-300">Your payment could not be processed. Please try again.</p>
          <button
            class="w-full rounded-md bg-violet-700 py-2 px-4 text-sm font-medium text-white"
            @click="router.push({ name: 'menu', params: { menu_slug: restoStore?.MENU_URL } })"
          >
            Back to Menu
          </button>
        </div>

        <div v-else class="space-y-4">
          <LoadingSpinner :isLoading="true" />
          <p class="text-gray-700 dark:text-gray-200">Confirming your order...</p>
        </div>
      </div>
    </div>
  </AppLayout>
</template>
